import React, { useEffect, useState } from 'react'
import {
  Card, Timeline, Spin, Checkbox, Tag, Row,
} from 'antd'
import parse from 'html-react-parser'

import { format } from 'date-fns'

import { fetch } from '../../utils/fetch'

const TimelineComment = ({ orderId }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [visibleComment, setVisibleComment] = useState(false)
  const [commentList, setCommentList] = useState([])

  const statusColor = (orderStatus) => {
    if (orderStatus === undefined) return 'gray'
    if (orderStatus === null) return 'gray'
    if (orderStatus === 'DRF') return 'gray'
    if (orderStatus === 'REJ') return '#F5222D'
    if (orderStatus === 'OBS') return '#FF6E40'
    if (orderStatus === 'ERR') return '#FFC53D'
    if (orderStatus === 'SOC') return '#1E88E5'
    if (orderStatus === 'PRC') return '#669966'
    if (orderStatus === 'ODI') return '#E53935'
    if (orderStatus === 'ODS') return '#7C4DFF'
    if (orderStatus === 'ODV') return '#512DA8'
    if (orderStatus === 'SOA') return '#52C41A'
    if (orderStatus === 'POC') return '#096DD9'
    if (orderStatus === 'POR') return '#CF1322'
    if (orderStatus === 'POA') return '#7CB305'
    if (orderStatus === 'PRD') return '#795548'
  }

  const getCommentList = async () => {
    await fetch({
      url: `/order/${orderId}/comment`,
    }).then((res) => {
      if (res.data?.success) {
        setCommentList(res.data?.data)
      }
    })
    setIsLoading(false)
  }

  useEffect(
    () => {
      getCommentList()
    }, [])

  useEffect(
    () => {
    }, [isLoading, visibleComment])

  return (
    <>
      <Spin spinning={isLoading} tip="Loading...">
        <Card>
          <Checkbox
            checked={visibleComment}
            style={{ float: 'left' }}
            onClick={() => setVisibleComment(!visibleComment)}
          >
            Show Comment
          </Checkbox>

          {
            visibleComment ? (
              <Timeline style={{ marginTop: '4em' }}>
                {commentList.map((item) => (
                  <Timeline.Item
                    color={statusColor(item?.statusCode)}
                  >
                    <>
                      <Row>
                        <Tag
                          style={{ marginBottom: '0.5rem' }}
                          color={statusColor(item?.statusCode)}
                        >{item?.status?.statusDescr ? item.status.statusDescr : '-'}
                        </Tag>
                        {item?.createdBy ? String(item.createdBy).toUpperCase() : '-'} {item?.createdAt ? format(new Date(item.createdAt), 'dd/MM/yyyy HH:mm:ss') : '-'}
                      </Row>

                      <Row>
                        {item?.remark ? parse(` ${item?.remark}`) : '-'}
                      </Row>
                    </>
                  </Timeline.Item>

                ))}
              </Timeline>

            ) : null
          }
        </Card>
      </Spin>
    </>
  )
}

export default TimelineComment
